<template>
    <vx-table class="xl:grid-cols-6-auto mb-8" rowBreakpoint="xl">
        <vx-table-row isHeader>
            <div class="lg:pl-6">Brand ID</div>
            <div>Name</div>
            <div>Entity</div>
            <div>Vetting</div>
            <div>Campaigns</div>
            <div>Synced</div>
        </vx-table-row>

        <slot></slot>
    </vx-table>
</template>

<script lang="ts" setup>
import { VxTable, VxTableRow } from '@voxie/frontend-components';
</script>
